import React from 'react';
import { Navbar } from 'react-bootstrap';
import * as logo from '../../styles/images/clippsLogo.png';
import history from '../../auth/history';

import './styles/Header.scss';

export default class Logo extends React.Component {
  redirect = () => {
    history.push(`/`);
  };

  render() {
    return (
      <Navbar.Brand>
        <img src={logo} width='120' alt='Clipps Logo' id='logo-img' onClick={this.redirect} />
      </Navbar.Brand>
    );
  }
}
